export default __webpack_public_path__ + "static/media/Collaborator-Logo.654b146f.svg";